import React from "react";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { formatDateTime } from "../../globalFunctions/DateTimeDisplayCleaner";

const extractTextFromTiptap = (raw, maxLength = 180) => {
  if (!raw) return "";

  let doc;
  try {
    doc = typeof raw === "string" ? JSON.parse(raw) : raw;
  } catch {
    return "";
  }

  if (!doc || doc.type !== "doc" || !Array.isArray(doc.content)) return "";

  const parts = [];

  const walk = (node) => {
    if (!node || parts.join(" ").length >= maxLength) return;

    if (node.type === "text" && node.text) {
      parts.push(node.text);
      return;
    }

    if (Array.isArray(node.content)) {
      node.content.forEach(walk);
    }
  };

  doc.content.forEach(walk);

  return parts.join(" ").replace(/\s+/g, " ").trim().slice(0, maxLength);
};

export default function NewsCard({ item }) {
  const image = item.image || item.imageUrl;
  const date = item.date || item.publishDate;
  const slug = item?.slug;

  const contentRaw = item.text || item.content;
  const excerpt = item.summary || extractTextFromTiptap(contentRaw);

  return (
    <a
      href={`/actualites/${slug}`}
      className="rounded-xl overflow-hidden bg-white border border-primary/5 shadow-lg 
        hover:shadow-xl transition-all hover:-translate-y-1 flex flex-col"
    >
      <div className="w-full h-48 bg-gray-100">
        <img
          src={image}
          alt={item.title}
          className="w-full h-full object-cover object-center"
          loading="lazy"
        />
      </div>

      <div className="p-5 flex flex-col flex-grow">
        <div className="text-xs text-gray-600 mb-2">{formatDateTime(date)}</div>

        <h3 className="font-bold text-lg text-[#3a3a3a] mb-2 line-clamp-2">
          {item.title}
        </h3>

        <p className="text-gray-500 line-clamp-3 min-h-[72px]">{excerpt}</p>

        <div className="mt-auto pt-3">
          <span
            className="inline-flex items-center gap-1 text-sm font-semibold text-[#3a3a3a]
              hover:underline underline-offset-2 decoration-2 cursor-pointer"
          >
            Consulter l’article
            <ArrowRightIcon className="h-4 w-4" />
          </span>
        </div>
      </div>
    </a>
  );
}
